import {useState, useEffect} from "react";
import {CoreAppResponse} from "../logic/APITypes";
import API from "../logic/API";
import {Resolution} from "../logic/FetchResolver";

/** A hook for fetching all core apps from the API */
function useCoreApps() {
  const [coreApps, setCoreApps] = useState<CoreAppResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const getCoreApps = async () => {
    setLoading(true);
    const res: Resolution<CoreAppResponse[]> = await API.getCoreApps();
    setLoading(false);
    if (res.success && res.payload) {
      const apps = res.payload.map((app) => {
        return {...app, logo: "data:image/svg+xml;base64," + app.logo};
      });
      setCoreApps(apps);
    }
  };

  useEffect(() => {
    getCoreApps();
  }, []);
  return {coreApps, loading};
}

export default useCoreApps;
